import { FloatingInventoryOwnerType } from '@bringg/types';
import { observer } from 'mobx-react';
import { Link } from '@bringg-frontend/ui';

import { useStores } from 'bringg-web/recipes';
import { NO_INFO } from '../consts';

type OwnerNameProps = {
	id: number;
	ownerType: FloatingInventoryOwnerType;
};
const OwnerName = ({ id, ownerType }: OwnerNameProps) => {
	const { driversStore, teamsStore } = useStores();

	if (!id) return getNoInfoComponent();

	switch (ownerType) {
		case FloatingInventoryOwnerType.DRIVER: {
			const user = driversStore.get(id);
			const name = user?.name || id.toString();
			const path = `/drivers/${id}`;
			return generateComponent({ path, name });
		}
		case FloatingInventoryOwnerType.TEAM: {
			const team = teamsStore.get(id);
			const name = team?.name || id.toString();
			const path = `/drivers/teams/${id}`;
			return generateComponent({ path, name });
		}
		case FloatingInventoryOwnerType.NONE:
		default:
			return getNoInfoComponent();
	}
};
export default observer(OwnerName);

const getNoInfoComponent = () => <>{NO_INFO}</>;

const generateComponent = ({ path, name }: { path: string; name: string }) => (
	<span>
		<Link to={path} title={name}>
			{name}
		</Link>
	</span>
);
